import { Component } from '@angular/core';
import { IPluginPreviewComponent } from '../../../../../interfaces/plugin-preview-component.interface';
import { CloudProviderData } from '../../../../../models/wizard-plugin-models/cloud-provider-data';

@Component({
  selector: 'app-cloud-provider-preview',
  templateUrl: './cloud-provider-preview.component.html',
  styleUrl: './cloud-provider-preview.component.css'
})
export class CloudProviderPreviewComponent implements IPluginPreviewComponent {
  public previewData: CloudProviderData | undefined;

  setData(data: any): void {
    if (data) {
      this.previewData = data as CloudProviderData;
    }
  }
}